import { motion, useReducedMotion } from "framer-motion";
import { StarDoodle, DotsDoodle, Squiggle } from "@/components/Decor";

export function PageHero({ overline, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#FFFDF7] via-[#FFF5DC] to-[#FFE9CC]">
      <StarDoodle className="absolute top-10 right-[8%] w-8 h-8 animate-float-slow hidden md:block" color="#FFB703" />
      <DotsDoodle className="absolute bottom-8 left-[6%] hidden md:block" color="#FF70A6" />
      <div className="container-mbf py-16 md:py-24 relative">
        {overline && <p className="overline mb-4" data-testid="page-hero-overline"><Squiggle className="w-8 h-3" color="#2A9D8F" />{overline}</p>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-espresso max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-stoneish max-w-2xl leading-relaxed font-medium">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ overline, title, subtitle, center = false }) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""} mb-10 md:mb-14`}>
      {overline && <p className={`overline mb-3 ${center ? "justify-center" : ""}`}>{overline}</p>}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-espresso">{title}</h2>
      {subtitle && <p className="mt-4 text-lg text-stoneish leading-relaxed font-medium">{subtitle}</p>}
    </div>
  );
}
